import axios from "axios";

const isDev =  true;
export default axios.create({
    baseURL: isDev ? "https://app.estructuraempresarial.com.mx/api" : "https://localhost:55306/api",
})